import documentsPropertiesProvider from './documentsPropertiesProvider';

export default {
  __init__: [ 'documentsPropertiesProvider' ],
  documentsPropertiesProvider: [ 'type', documentsPropertiesProvider ]
};